import { useEffect, useState } from 'react'
import { formatCountdown, countdown } from '../utils/format.js'

// Cuenta atrás en vivo hacia el cierre de una subasta.
// Muestra "Beendet" cuando ya cerró.
export default function Countdown({ closesAt }) {
  const [t, setT] = useState(() => countdown(closesAt))

  useEffect(() => {
    if (!closesAt) return
    const iv = setInterval(() => setT(countdown(closesAt)), 1000)
    return () => clearInterval(iv)
  }, [closesAt])

  if (!closesAt) return null

  if (t.ended) {
    return <span className="countdown countdown-ended">Beendet</span>
  }

  const part = (v, suf) => (
    <span className="cd-part">
      <span className="cd-num">{String(v).padStart(2, '0')}</span>
      <span className="cd-suf">{suf}</span>
    </span>
  )

  return (
    <span className="countdown" title={`Endet am ${new Date(closesAt).toLocaleString('de-DE')}`}>
      {t.days > 0 && part(t.days, 'T')}
      {part(t.hours, 'h')}
      {part(t.mins, 'm')}
      {part(t.secs, 's')}
    </span>
  )
}
